<template>
  <div class="home" >
    
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    // HelloWorld
  },
  mounted() {
    //  $(".owl-carousel").owlCarousel(
    //    {
    //       loop:true,
    //       autoplay:false,
    //       autoplayTimeout:5000,
    //       // autoWidth:true,
    //       items:1
    //    }
    //  );
  },
  beforeCreate: function() {
      document.body.className = 'bodyhome';
  }
};
</script>

<style>
  body, html {
      height: 100%;
      margin: 0px;
  }

  .fh {
      /* Full height */
      height: 100%;
  }

  .bodyhome .bg {  
    background-color: none;
  }

  .home {
    background-color: red;    
  }
</style>